// import baseLogo from '../../assets/images/logo-base@2x.png';
import cvsHealthLogo from '../../assets/images/CVS-CATCH-MS-SPM-CVS-Logo.svg'
import cvsAndDELogo from '../../assets/images/CVS-CATCH-MS-SPM-DE-CATCH-Logos@2x.png'

const placeholder = 'http://via.placeholder.com/200x50'

const Footer = {
  title: 'Footer',
  rightLogo: {
    image: cvsHealthLogo,
    altText: 'Discovery Education Logo',
    text: 'Generously supported by',
  },
  leftLogo: {
    image: cvsAndDELogo,
    // image: placeholder,
    altText: 'cvs Card Logo',
    text: 'In partnership with',
  },
}

export default Footer



//////////////////
// WEBPACK FOOTER
// ../shared/src/components/Footer/index.js
// module id = 506
// module chunks = 0